import dynamic from 'next/dynamic';
import { AddToCartTastic } from './add-to-cart';
import { HeaderTastic } from './header';
import { LoadCartTastic } from './load-cart';
import { NotFoundTastic } from './not-found';
import { OrderDetailsTastic } from './order-details';
import { OrderHistoryTastic } from './order-history';
import { RedeemDiscountTastic } from './redeem-discount';
import { ThankYouTastic } from './thank-you';
import { TasticRegistry } from './types';

const CheckoutTastic = dynamic(() => import('./checkout'));

export const tastics = {
  'ui/add-to-cart': AddToCartTastic,
  'ui/checkout': CheckoutTastic,
  'ui/header': HeaderTastic,
  'ui/load-cart': LoadCartTastic,
  'ui/not-found': NotFoundTastic,
  'ui/thank-you': ThankYouTastic,
  'ui/order-history': OrderHistoryTastic,
  'ui/redeem-discount': RedeemDiscountTastic,
  'ui/order-details': OrderDetailsTastic,
} as TasticRegistry;
